import React from "react";
import "./styles.scss";

const CheckBox = ({ 
  id = 0, 
  checked, 
  setChecked, 
  text, 
  className = "default", 
  disabled = false // New parametric prop with default false
}) => {
  return (
    <span 
      className={`form-group ${className}`} 
      style={{ 
        marginTop: "12px",
        opacity: disabled ? 0.4 : 1 // Conditional opacity
      }}
    >
      <input 
        type="checkbox" 
        id={id} 
        checked={checked} 
        onChange={disabled ? undefined : () => setChecked(!checked)} 
        disabled={disabled} // Now controlled by prop
      />
      <label className="checkbox-label" htmlFor={id}>
        {text}
      </label>
    </span>
  );
};

export default CheckBox;